import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ShareIcon, Typography } from '@dev/ee-components';
import { getCheckoutCreatorStore } from '@/store/checkoutCreator/actions';
import { useGetProductCurrencySettings } from '@/components/CheckoutCreator/hooks/useGetProductCurrencySettings';
import { Step1ContentItem, Step1ContentWrapper, Step1Link, Step1LinkWrapper } from './styles';

export const Step1Content = (): JSX.Element => {
    const { t } = useTranslation();
    const { checkoutObject } = useSelector(getCheckoutCreatorStore);
    const { formatProductPrice } = useGetProductCurrencySettings();

    return (
        <Step1ContentWrapper>
            <Step1ContentItem>
                <Typography variant="h3">{t('productname')}:</Typography>
                <Typography variant="body1">{checkoutObject?.Name}</Typography>
            </Step1ContentItem>
            <Step1ContentItem>
                <Typography variant="h3">{t('productprice')}:</Typography>
                <Typography variant="body1">{formatProductPrice(checkoutObject?.Currency, checkoutObject?.ProductPrice)}</Typography>
            </Step1ContentItem>
            <Step1ContentItem>
                <Typography variant="h3">{t('productfile')}:</Typography>
                <Step1LinkWrapper>
                    <ShareIcon />
                    <Step1Link><Typography variant="body1">{checkoutObject?.DownloadUrl}</Typography></Step1Link>
                </Step1LinkWrapper>
            </Step1ContentItem>
        </Step1ContentWrapper>
    );
};
